import React from 'react';
import styles from './PaymentStatus.module.css';

const PaymentStatus = ({ status, paymentMethod }) => {
  const getStatusConfig = (status) => {
    switch (status) {
      case 'Completed':
        return {
          label: 'Paid',
          className: styles.completed,
          icon: '✅'
        };
      case 'Pending':
        return {
          label: 'Pending',
          className: styles.pending,
          icon: '⏳'
        };
      case 'Failed':
        return {
          label: 'Failed',
          className: styles.failed,
          icon: '❌'
        };
      default:
        return {
          label: 'Unknown',
          className: styles.unknown,
          icon: '❓'
        };
    }
  };

  const statusConfig = getStatusConfig(status);

  return (
    <div className={`${styles.paymentStatus} ${statusConfig.className}`}>
      <span className={styles.icon}>{statusConfig.icon}</span>
      <span className={styles.label}>{statusConfig.label}</span>
      {paymentMethod && (
        <span className={styles.method}>({paymentMethod})</span>
      )}
    </div>
  );
};

export default PaymentStatus; 